var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.707.793A1 1 0 00.293 2.207L8.086 10 .293 17.793a1 1 0 101.414 1.414L9.5 11.414l7.764 7.764a1 1 0 001.414-1.415L10.914 10l7.764-7.763A1 1 0 0017.263.822L9.5 8.586 1.707.793z",
    fill: "#333230"
  })));
}
export default SvgCloseHeader;